// @flow

import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';

import BackgroundImage from 'containers/fragments/BackgroundImageContainer';

import type { SourceSetType } from 'types/Article';

import { getPlaceholder } from 'utils/assetsUtils';

type Props = {
  slug: string,
  title: string,
  date: Date,
  count: number,
  illustration: string,
  srcset: SourceSetType
};

export default class CardAlbum extends PureComponent<Props> {
  render() {
    const { title, date, count, illustration, srcset, slug } = this.props;

    return (
      <Link
        to={`/mediatheque/${slug}`}
        title={title && `Voir les documents de "${title}"`}
        className="box card card--content card--date card--day"
      >
        <BackgroundImage
          className="card__thumbnail img-blue"
          illustration={illustration || getPlaceholder()}
          srcset={srcset}
        />

        {count > 0 && <div className="card__label label label--transparent">{count}</div>}
        <div className="card__body">
          <h3 className="card__title ft-h5">{title}</h3>
          <p className="card__desc ft-h6">{date.toLocaleDateString()}</p>
        </div>
      </Link>
    );
  }
}
